const PROJECT_TABS = {
  TASKS: 'tasks',
  TASK: 'task',
  NOTES: 'notes',
  REPOSITORY: 'repository',
};

export default PROJECT_TABS;
